<template>
	<svg xmlns="http://www.w3.org/2000/svg" height="180" width="180" id="Layer_1" data-name="Layer 1" viewBox="0 0 172.54 152.31">
		<defs></defs>
		<title>flat-bed-scanner</title>
		<polygon class="cls-1" points="125.9 64.25 31.83 64.25 27.88 12.66 93.9 12.66 125.9 64.25" />
		<path class="cls-2" d="M98.51,3.45l56,85.25" transform="translate(-0.03 0)" />
		<path class="cls-2" d="M11.42,6.42c-1,33.61-.29,42.74-1.71,80.38" transform="translate(-0.03 0)" />
		<path class="cls-3" d="M143.54,151.79c12.92.58,16.75-12.32,20.92-25.26,4.92-15.28,8.83-31.16,7.25-32.73" transform="translate(-0.03 0)" />
		<path class="cls-2" d="M18.51,3.45c0,35,.5,46.2,2.67,83.35" transform="translate(-0.03 0)" />
		<path class="cls-1" d="M22.51,1.36C59.37.27,49,1.36,94.37,1.45" transform="translate(-0.03 0)" />
		<path
			class="cls-3"
			d="M143.08,151.79,28.62,150.23l.31-40.49A5.78,5.78,0,0,1,34.72,104h0l115.89,1.53a4.56,4.56,0,0,1,4.48,4.62h0a4.84,4.84,0,0,1-.18,1.2Z"
			transform="translate(-0.03 0)"
		/>
		<path
			class="cls-4"
			d="M109.62,121.85l-40.69-.46L69,109.78a1.92,1.92,0,0,1,2.08-1.65l41.17.43c1.07,0,1.83.84,1.53,1.67Z"
			transform="translate(-0.03 0)"
		/>
		<path
			class="cls-4"
			d="M153.14,100.85l-124.52-.32.35-8c0-.63,2.88-1.13,6.37-1.12L150.1,92.78c3.1,3.33,3.26,4.2,3.31,5.94Z"
			transform="translate(-0.03 0)"
		/>
		<circle class="cls-4" cx="140.96" cy="112.22" r="5" />
		<circle class="cls-4" cx="131.96" cy="144.22" r="5" />
		<circle class="cls-4" cx="39.96" cy="144.22" r="5" />
		<circle class="cls-4" cx="42.56" cy="111.68" r="5" />
		<circle class="cls-4" cx="63.69" cy="68.81" r="2.14" />
		<path
			class="cls-4"
			d="M83.93,67.23c8-.18,8.06,0,16.43.11a1.51,1.51,0,0,1,.82,1.52c0,.9-.52,1.66-.9,1.63a142.35,142.35,0,0,0-16-.15c-.67,0-2.11-.48-2.1-1.71C82.17,67.82,83.23,67.23,83.93,67.23Z"
			transform="translate(-0.03 0)"
		/>
		<path
			class="cls-3"
			d="M5.6,87.91c-.21,1.63-1,4.75-1,6.39-.14,8.88,0,12.37-.34,16.8-.09,1.15-1.83.82-2.75,2.17-.18.27-1.42,2.11-.8,3.78.55,1.45,2,1.32,2.86,2.85a5.51,5.51,0,0,1,.37,3.77c-1.2,7.61-1.83,11.6-.45,15a23,23,0,0,0,3.45,5.56c1.56,1.81,3.22,2.88,6.86,4.6A21.06,21.06,0,0,0,20,150.54a32.88,32.88,0,0,0,8.23.34"
			transform="translate(-0.03 0)"
		/>
		<path class="cls-5" d="M21.14,87.9a5.5,5.5,0,0,0,1.79,1.6,5.86,5.86,0,0,0,3.31.69" transform="translate(-0.03 0)" />
		<polyline class="cls-5" points="10.52 90.22 15.16 94.42 19.39 96.15 23.67 97.05" />
		<path
			class="cls-5"
			d="M7.43,92.47a16.71,16.71,0,0,0,3.65,5.38,21.58,21.58,0,0,0,2.85,2.28,24.35,24.35,0,0,0,2.86,1.72"
			transform="translate(-0.03 0)"
		/>
		<path class="cls-5" d="M166.4,92.59a8,8,0,0,1-3.09,3.2,10.34,10.34,0,0,1-3.43,1,21.43,21.43,0,0,1-4.45.34" transform="translate(-0.03 0)" />
		<path class="cls-5" d="M158.28,105.05a13,13,0,0,0,4.58,0,12.5,12.5,0,0,0,3.88-1.38" transform="translate(-0.03 0)" />
		<path
			class="cls-3"
			d="M22.93,1.09c-2.76-.2-6.44-.9-7.66-.43A28.32,28.32,0,0,0,11.38,2.3c-1.72.81-2,2.07-2.51,2.63A6.79,6.79,0,0,0,7.43,8.47a11.62,11.62,0,0,0-.23,2.76c.1,2.48-.56,32.94-1.6,76.68"
			transform="translate(-0.03 0)"
		/>
		<path
			class="cls-3"
			d="M94.86,1a15,15,0,0,1,3.65.46,16.78,16.78,0,0,1,2.29.8,17.78,17.78,0,0,1,2.06,1,29.9,29.9,0,0,1,3.07,2.06c1.79,1.41,29,38,65.77,88.52"
			transform="translate(-0.03 0)"
		/>
	</svg>
</template>

<script>
	export default {
		name: 'IQubeScannerSVG'
	};
</script>

<style scoped>
	.cls-1,
	.cls-2 {
		fill: gray;
	}
	.cls-1,
	.cls-3,
	.cls-4 {
		stroke: #000;
	}
	.cls-1,
	.cls-2,
	.cls-3,
	.cls-4,
	.cls-5 {
		stroke-miterlimit: 10;
	}
	.cls-2,
	.cls-5 {
		stroke: #eaeaea;
	}
	.cls-3,
	.cls-4,
	.cls-5 {
		fill: none;
	}
	.cls-4 {
		stroke-width: 0.5px;
	}
</style>
